import React from "react";
import styled, { keyframes } from "styled-components";
import { TextFont, Colors } from "../../config";
import NewBadge from "../BusinessTripComponents/Newbadge";
import BizButton from "../BusinessTripComponents/Button";
const flightImage = require("../../assets/images/flight.png");

const NavbarItemActive = ({ labelText,showBizTripTutorial }) => {
  return (
    <>
      <ActiveItemWrapper>
        {labelText === "Book Business Trip" && <NewBadge bottomPixel="36px" showBizTripTutorial={showBizTripTutorial}/>}

        {labelText === "Book Business Trip" && showBizTripTutorial ? (
          <SpotLight>
            {/* <NewBadge bottomPixel="24px" /> */}
            <TopText>
              <TextFont fontColor={Colors.brandTwo}>{labelText}</TextFont>
            </TopText>
            <SpotLightImg
              src={require("../../assets/images/biz-trip-spotlight.png")}
            />
            <ArrowImg src={require("../../assets/images/biz-trip-arrow.png")} />
          </SpotLight>
        ) : (
          <>
            <TextFont fontColor={Colors.white}>{labelText}</TextFont>
            <LineWithFlight>
              <FlightImage src={flightImage} alt="flight_image" />
            </LineWithFlight>
          </>
        )}
      </ActiveItemWrapper>
    </>
  );
};

export default NavbarItemActive;
const ArrowImg = styled.img`
  position: absolute;
  top: 0px;
  left: 220px;
  z-index: 11;
  transform: rotate(-15deg);
  transform-origin: center center;
  @media only screen and (max-width: 1480px) {
    top: 0px;
    left: 180px;
    transform: rotate(0deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1400px) {
    top: 15px;
    left: 130px;
    transform: rotate(15deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1200px) {
    top: 15px;
    left: 130px;
    transform: rotate(15deg);
    transform-origin: center center;
  }
  @media only screen and (max-width: 1149px) {
    top: 15px;
    left: 110px;
    transform: rotate(25deg);
    transform-origin: center center;
  }
      @media only screen and (max-width: 1077px) {
    top: 30px;
    left: 95px;
    transform: rotate(25deg);
    transform-origin: center center;
  }
`;

const SpotLightImg = styled.img`
  position: absolute;
  z-index: 11;
  top: -180px;
  left: -80px;
`;

const TopText = styled.div`
  z-index: 99;
  position: relative;
`;

const SpotLight = styled.div`
  position: relative;
`;

const ActiveItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  margin-bottom: 0.375rem;
  width: fit-content;
  position: relative;
`;
const flight = keyframes`
  from {left: 0rem;}
  to {left: calc(100% - 2rem);}
`;
const LineWithFlight = styled.div`
  background: ${Colors.white};
  height: 0.1875rem;
  border-radius: 0.125rem;
  display: flex;
  align-items: center;
`;
const FlightImage = styled.img`
  padding: 0rem 0.125rem;
  position: relative;
  animation: ${flight} 0.2s ease-in forwards;
`;
